import React, { useState, useEffect } from 'react';
import { Card, Button, Badge, Modal, Form } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { newsAPI } from '../services/api';
import DOMPurify from 'dompurify';

const NewsFeed = () => {
  const { isAdmin, isHR } = useAuth();
  const [news, setNews] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    is_pinned: false
  });

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = async () => {
    try {
      const response = await newsAPI.getAll();
      setNews(response.data);
    } catch (error) {
      console.error('Error fetching news:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await newsAPI.create(formData);
      setShowModal(false);
      setFormData({ title: '', content: '', is_pinned: false });
      fetchNews();
      alert('News posted successfully!');
    } catch (error) {
      alert('Error posting news');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this post?')) {
      try {
        await newsAPI.delete(id);
        fetchNews();
      } catch (error) {
        alert('Error deleting post');
      }
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 style={{ color: '#635bff' }}>Company News Feed</h2>
        {(isAdmin || isHR) && (
          <Button variant="primary" onClick={() => setShowModal(true)}>
            + Create Post
          </Button>
        )}
      </div>

      {news.map((item) => (
        <Card key={item.id} className="mb-3">
          <Card.Body>
            <div className="d-flex justify-content-between align-items-start mb-2">
              <h5>{item.title}</h5>
              {item.is_pinned && <Badge bg="warning">Pinned</Badge>}
            </div>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.content) }} />
            <div className="d-flex justify-content-between align-items-center">
              <small className="text-muted">
                Posted on {new Date(item.created_at).toLocaleString()}
              </small>
              {(isAdmin || isHR) && (
                <Button
                  size="sm"
                  variant="outline-danger"
                  onClick={() => handleDelete(item.id)}
                >
                  Delete
                </Button>
              )}
            </div>
          </Card.Body>
        </Card>
      ))}

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create News Post</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Title</Form.Label>
              <Form.Control
                required
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Content</Form.Label>
              <Form.Control
                required
                as="textarea"
                rows={5}
                value={formData.content}
                onChange={(e) => setFormData({ ...formData, content: e.target.value })}
              />
            </Form.Group>
            <Form.Check
              type="checkbox"
              label="Pin this post"
              checked={formData.is_pinned}
              onChange={(e) => setFormData({ ...formData, is_pinned: e.target.checked })}
              className="mb-3"
            />
            <Button type="submit" variant="primary">Post</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NewsFeed;
